import { StyledTableCell, StyledTableRow } from 'ui/StyledTable';
import { useNavigate } from 'react-router';
import { nanoid } from '@reduxjs/toolkit';
import { ItemWithId } from 'services/constants/types';
import { ETableStructureType } from 'services/constants/tableStructureTypes';
import { EasTableValue } from '../EasTableValue/index';
import { TMtdRowProps } from './types';

export const EasRow = <T extends ItemWithId>({
	item,
	setSelectedRow,
	index,
	selectedRow,
	tableStructure,
	handleAction,
	checkedRow = false,
	handleLink,
	highlightedRow,
}: TMtdRowProps<T>) => {
	const navigate = useNavigate();

	const linkSelector = tableStructure.find((i) => i.type === ETableStructureType.LINK)?.selector;

	const handleLinkClick = () => {
		if (linkSelector) {
			const id = item?.[linkSelector];
			if (handleLink) {
				handleLink(id as number);
			} else navigate(String(id));
		}
	};
	const handleActionStopPropagation = (
		event: React.MouseEvent<HTMLButtonElement>,
		id: number,
		type: string,
	) => {
		event.stopPropagation();
		handleAction?.(id, type);
	};

	return (
		<StyledTableRow
			key={nanoid()}
			sx={{
				'&:last-child td, &:last-child th': { border: 0 },
				background: checkedRow
					? '#03629338!important'
					: highlightedRow === index
						? '#0362937a!important'
						: selectedRow === index
							? '#03629338!important'
							: 'auto',
				p: '0px',
				m: '0px',
				height: '35px!important',
				cursor: linkSelector ? 'pointer' : 'default',
			}}
			onClick={handleLinkClick}
			onMouseOver={() => setSelectedRow(index)}
		>
			{tableStructure?.map((filter) => {
				if (filter.show === false) return null;
				return (
					<StyledTableCell
						key={nanoid()}
						align={filter?.align ?? 'center'}
						colSpan={filter?.colSpan}
						sx={{
							padding: '4px 8px 4px 8px',
							verticalAlign: 'middle',
							lineHeight: '1rem',
							maxWidth: '250px',
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							position: 'relative',
							p: '4px!important',
							m: '0px',
						}}
					>
						<EasTableValue
							type={filter?.type}
							value={
								filter?.value
									? filter.value(item)
									: filter?.selector !== 'actions'
										? item?.[filter?.selector]
										: item?.id
							}
							tableStructureItem={filter}
							item={item}
							selectedRow={selectedRow}
							index={index}
							handleAction={handleActionStopPropagation}
						/>
					</StyledTableCell>
				);
			})}
		</StyledTableRow>
	);
};
